/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useText } from 'hooks';

import { MOBILE, TABLET, DESKTOP, TO_DESKTOP } from 'helpers/styles/media';
import { ChangeableButtonBg } from 'helpers/components';

import Form from '../Form/FormMain';
import { FormWrapperStyles } from '../UI/UI';

const Header = ({
  openPopup,
}) => {
  return (
    <Wrapper>
      <Content>
        <Title1>{useText('top__t1', true)}</Title1>
        <Title2>{useText('top__t2', true)}</Title2>
        <Title3>
          {useText('top__t3', true)}
        </Title3>
        <ChangeableButtonBg
          id="header-button-background"
          defaultColor='#003399'
        >
          <Button
            onClick={openPopup}
          >
            {useText('top__button', true)}
          </Button>
        </ChangeableButtonBg>
      </Content>
      <FormWrapper>
        <Form />
      </FormWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: ${({ theme: { imgUrl } }) => imgUrl('77786_Desc.webp')};
  color: #fff;

  @media ${TABLET} {
    position: relative;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('77786_Tablet.webp')};
    color: #fff;
  }

  @media ${MOBILE} {
    position: relative;
    background-repeat: no-repeat;
    background-position: left;
    background-size: cover;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('77786_Mobile.webp')};
    color: #fff;
    height: 740px;
  }
`;

const Content = styled.div`
  position: relative;
  text-align: center;

  @media ${DESKTOP} {
    transform: translateX(0px);
    padding-top: 70px;
    max-width: 495px;
    margin: 0 auto;
  }

  @media ${TABLET} {
    padding-top: 47px;
    max-width: 740px;
    padding-left: 200px;
    margin: 0 auto;
  }

  @media ${MOBILE} {
    padding-top: 52px;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
  }
`;

const Title1 = styled.h2`
  color: #313131;
  font-weight: 500;
  margin: 0;

  @media ${DESKTOP} {
    font-size: 34px;
    line-height: 43px;
    margin-bottom: 2px;
  }

  @media ${TABLET} {
    font-size: 38px;
    line-height: 42px;
    margin-bottom: 20px;
    font-weight: 400;
  }

  @media ${MOBILE} {
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 16px;
    font-weight: 400;
  }
`;

const Title2 = styled.h1`
  margin: 0;
  font-weight: bold;
  color: #00256e;
  letter-spacing: 0;

  @media ${DESKTOP} {
    font-size: 64px;
    margin-bottom: 15px;
    margin-top: 15px;
  }

  @media ${TABLET} {
    font-size: 68px;
    line-height: 73px;
    margin-bottom: 16px;
  }

  @media ${MOBILE} {
    font-size: 43px;
    line-height: 64px;
    margin-bottom: 10px;
  }
`;

const Title3 = styled.div`
  font-weight: bold;
  color: #313131;

  @media ${DESKTOP} {
    font-size: 34px;
    line-height: 43px;
    margin-bottom: 18px;
  }

  @media ${TABLET} {
    font-size: 38px;
    line-height: 42px;
    margin-bottom: 32px;
  }

  @media ${MOBILE} {
    font-size: 21px;
    line-height: 36px;
    margin-bottom: 24px;
  }
`;

const Button = styled.button`
  display: inline-flex;
  min-height: 57px;
  border-radius: 30px;
  border: none;
  color: #fff;
  font-size: 20px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-align: center;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
  padding: 5px 25px;
  min-width: 265px;
  cursor: pointer;
  box-shadow: 0px 4.51487px 10.1585px rgba(0, 0, 0, 0.18);
  margin-bottom: 100px;

  @media ${DESKTOP} {
    &:hover {
      transform: scale(1.08);
    }
  }

  @media ${TABLET} {
    padding: 20px 25px;
    font-size: 21px;
    line-height: 23px;
    min-width: 240px;
    min-height: 51px;
    &:active {
      transform: scale(1.08);
    }
  }

  @media ${MOBILE} {
    padding: 20px 25px;
    font-size: 18px;
    line-height: 20px;
    min-width: 199px;
    min-height: 43px;
    &:active {
      transform: scale(1.08);
    }
  }
`;

const FormWrapper = styled.div`
  ${FormWrapperStyles}

  max-width: 360px;
  color: red;

  @media ${DESKTOP} {
    position: absolute;
    top: -130px;
    right: 50%;
  }

  @media ${TO_DESKTOP} {
    display: none;
    position: relative;
    margin: 0 auto;
  }

  @media ${TABLET} {
    margin-bottom: -76px;
    max-width: 368px;
  }

  @media ${MOBILE} {
    margin-bottom: -56px;
  }
`;

Header.propTypes = {
  openPopup: PropTypes.func.isRequired,
};

export default Header;
